export default __webpack_public_path__ + "static/media/cyclops_1.a6ac9511.svg";